import { useContext, useState } from "react";
import styles from "./Placeholder.module.css";
import { Button, Divider } from "@shopify/polaris";
import { BundleTypes } from "../constants";
import { PlaceholderContext } from "./Placeholder";
import DesignTabsWrapper from "../../../components/DesignTabsWrapper/DesignTabsWrapper";
import { CombinedBundleConfigInterface } from "../Types";
import DesignProductCard from "../CommonFields/DesignProductCard";
import DesignStepsPage from "../CommonFields/DesignStepsPage";
import DesignFooterCard from "../CommonFields/DesignFooterCard";
import DesignGeneralCard from "../CommonFields/DesignGeneralCard";

const PlaceholderDesignForm = () => {
    const context = useContext(PlaceholderContext);
    const [activeDesignTab, setActiveDesignTab] = useState(0);

    if (!context) return;
    const {
        fields: {
            bundles_design: {
                default_cta,
                bundle_title_color,
                bundle_title_style,
                bundle_title_size,
                bundle_widget_bg,
                bundle_widget_font_family,
                product_background_color,
                product_border_color,
                product_name_color,
                product_name_style,
                product_name_size,
                product_price_color,
                product_price_style,
                product_price_size,
                variant_selector_text_size,
                variant_selector_text_style,
                variant_selector_text_color,
                product_custom_img_size,
                product_custom_img_size_mobile,
                product_img_show,
                border_width,
                border_radius,
                highlighted_price_tag_size,
                highlighted_price_tag_color,
                highlighted_price_tag_style,
                total_footer_text_size,
                total_footer_text_style,
                total_footer_price_text_style,
                total_footer_price_text_size,
                total_footer_price_text_color,
                total_footer_background_color,
                total_footer_text_color,
                add_to_cart_bg_color,
                add_to_cart_border_radius,
                add_to_cart_border_color,
                add_to_cart_text_color,
                add_to_cart_text_size,
                add_to_cart_text_style,
                secondary_cta_bg_color,
                secondary_cta_text_color,
                tertiary_cta_bg_color,
                tertiary_cta_text_color,
                step_label_color,
                step_label_size,
                step_label_style,
                order_summary_bg_color,
                order_summary_header_text_color,
                order_summary_header_text_size,
                order_summary_header_text_style,
                order_summary_rows_text_color,
                order_summary_rows_text_size,
                order_summary_rows_text_style,
                special_text_background_color,
                special_text_color,
                special_text_style,
                special_text_font_size,
                added_quantity_bg_color,
                added_quantity_text_color,
                added_quantity_text_style,
                added_quantity_text_size,
                edit_bundle_cta_style,
                edit_bundle_cta_size,
                popup_cta_bg_color,
                dotted_border_color,
                step_container_bg,
                step_page_title_size,
                step_page_title_style,
                step_page_title_color,
                step_page_subtitle_color,
                step_page_subtitle_size,
                step_page_subtitle_style,
            },
        },
        handleNext,
        inspectorTarget,
        submit,
        validate,
        bundleConfig,
        dispatchBundleConfig,
    } = context;

    const showFooterKeys = !default_cta?.value;

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: 10 }}>
                <Divider borderColor="border" />
            </div>

            <DesignTabsWrapper
                bundleConfig={bundleConfig as CombinedBundleConfigInterface}
                activeDesignTab={activeDesignTab}
                setActiveDesignTab={setActiveDesignTab}
                validate={validate}
                submit={submit}
                inspectorTarget={inspectorTarget}
            >
                {activeDesignTab == 0 && (
                    <DesignGeneralCard
                        bundleType={BundleTypes.BB_PLACEHOLDER}
                        dispatchBundleConfig={dispatchBundleConfig}
                        bundle_widget_bg={bundle_widget_bg}
                        bundle_title_color={bundle_title_color}
                        bundle_widget_font_family={bundle_widget_font_family}
                        bundle_title_style={bundle_title_style}
                        bundle_title_size={bundle_title_size}
                        step_container_bg={step_container_bg}
                        dotted_border_color={dotted_border_color}
                    />
                )}
                {activeDesignTab == 1 && (
                    <DesignProductCard
                        dispatchBundleConfig={dispatchBundleConfig}
                        bundleType={BundleTypes.BB_PLACEHOLDER}
                        cardName={"Product"}
                        product_background_color={product_background_color}
                        product_border_color={product_border_color}
                        product_name_color={product_name_color}
                        product_price_color={product_price_color}
                        highlighted_price_tag_style={highlighted_price_tag_style}
                        highlighted_price_tag_size={highlighted_price_tag_size}
                        highlighted_price_tag_color={highlighted_price_tag_color}
                        product_name_style={product_name_style}
                        product_name_size={product_name_size}
                        product_price_style={product_price_style}
                        product_price_size={product_price_size}
                        variant_selector_text_size={variant_selector_text_size}
                        variant_selector_text_style={variant_selector_text_style}
                        variant_selector_text_color={variant_selector_text_color}
                        border_width={border_width}
                        border_radius={border_radius}
                        add_to_cart_bg_color={add_to_cart_bg_color}
                        add_to_cart_border_color={add_to_cart_border_color}
                        add_to_cart_text_color={add_to_cart_text_color}
                        add_to_cart_text_size={add_to_cart_text_size}
                        add_to_cart_text_style={add_to_cart_text_style}
                        product_custom_img_size={product_custom_img_size}
                        product_custom_img_size_mobile={product_custom_img_size_mobile}
                        product_img_show={product_img_show}
                        added_quantity_bg_color={added_quantity_bg_color}
                        added_quantity_text_color={added_quantity_text_color}
                        added_quantity_text_style={added_quantity_text_style}
                        added_quantity_text_size={added_quantity_text_size}
                    />
                )}

                {activeDesignTab == 2 && (
                    <DesignStepsPage
                        dispatchBundleConfig={dispatchBundleConfig}
                        bundleType={BundleTypes.BB_PLACEHOLDER}
                        cardName={"Steps"}
                        step_label_color={step_label_color}
                        step_label_size={step_label_size}
                        step_label_style={step_label_style}
                        secondary_cta_bg_color={secondary_cta_bg_color}
                        secondary_cta_text_color={secondary_cta_text_color}
                        tertiary_cta_bg_color={tertiary_cta_bg_color}
                        tertiary_cta_text_color={tertiary_cta_text_color}
                        total_footer_background_color={total_footer_background_color}
                        step_page_title_color={step_page_title_color}
                        step_page_title_size={step_page_title_size}
                        step_page_title_style={step_page_title_style}
                        step_page_subtitle_color={step_page_subtitle_color}
                        step_page_subtitle_size={step_page_subtitle_size}
                        step_page_subtitle_style={step_page_subtitle_style}
                    />
                )}

                {activeDesignTab == 3 && (
                    <DesignFooterCard
                        dispatchBundleConfig={dispatchBundleConfig}
                        bundleType={BundleTypes.BB_PLACEHOLDER}
                        showFooterKeys={showFooterKeys}
                        add_to_cart_bg_color={add_to_cart_bg_color}
                        add_to_cart_border_color={add_to_cart_border_color}
                        add_to_cart_text_color={add_to_cart_text_color}
                        total_footer_text_size={total_footer_text_size}
                        total_footer_text_style={total_footer_text_style}
                        total_footer_text_color={total_footer_text_color}
                        total_footer_price_text_color={total_footer_price_text_color}
                        total_footer_price_text_size={total_footer_price_text_size}
                        total_footer_price_text_style={total_footer_price_text_style}
                        add_to_cart_text_size={add_to_cart_text_size}
                        add_to_cart_text_style={add_to_cart_text_style}
                        add_to_cart_border_radius={add_to_cart_border_radius}
                        order_summary_bg_color={order_summary_bg_color}
                        order_summary_header_text_color={order_summary_header_text_color}
                        order_summary_header_text_size={order_summary_header_text_size}
                        order_summary_header_text_style={order_summary_header_text_style}
                        order_summary_rows_text_color={order_summary_rows_text_color}
                        order_summary_rows_text_size={order_summary_rows_text_size}
                        order_summary_rows_text_style={order_summary_rows_text_style}
                        special_text_background_color={special_text_background_color}
                        special_text_color={special_text_color}
                        special_text_font_size={special_text_font_size}
                        special_text_style={special_text_style}
                    />
                )}
            </DesignTabsWrapper>

            {handleNext && (
                <>
                    <div className={styles.dividerStyle}>
                        <Divider borderColor="border" />
                    </div>
                    <div className={styles.bottomRowCta}>
                        <Button onClick={() => handleNext(0, "Content")}>Back</Button>
                        <Button onClick={() => handleNext(2, "Target")}>Next</Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default PlaceholderDesignForm;
